import React from 'react'

import { ReactComponent as BackspaceIcon } from 'assets/svg/shared/backspace.svg'

export const BackspaceButton = ({ onBackspace }) => (
    <button type="button" onClick={onBackspace} className="dialpad__backspace">
        <BackspaceIcon />
    </button>
)
